import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken } from '../useAuth';
import { useMutation } from '../useMutation';

interface UseMakePrimaryEmailProps {
  email: string;
  onSuccess?: (res: Api.UserObject | ResponseObject) => void;
}

export function useMakePrimaryEmail({ email, onSuccess }: UseMakePrimaryEmailProps) {
  const token = useAuthToken();
  const { setAlert } = useAppContext();

  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'makePrimaryEmail',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/user/email/make-primary`,
        body: { email },
        token
      }).then((response: TypeAny) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }
        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
